<app-elevation-section [title]="languageService.LNG('Label.Articles')">
    <div class="grid-totals-wrapper">
        <dx-select-box #selectBox
          [dataSource]="transportArticles"
          displayExpr="DisplayName"
          searchExpr="DisplayName"
          valueExpr="TransportArticleId"
          [searchEnabled]="true"
          [showClearButton]="true"
          [(value)]="newTransportArticle.TransportArticleId"
          [readOnly]="isEditingDisabled"
          placeholder="{{languageService.LNG('Label.Articles')}}">
        </dx-select-box>
        <dx-text-box placeholder="{{languageService.LNG('Label.Quantity')}}" 
          [(value)]="newTransportArticle.Quantity" 
          [readOnly]="isEditingDisabled"
          (onEnterKey)="createNewArticle()"></dx-text-box>
    </div>
    <dx-data-grid #datagriddx [dataSource]="gridDataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [height]="225"
                style="padding-bottom: 10px;"
                (onRowUpdating)="onRowUpdating($event)"
                (onRowRemoving)="onRowRemoving($event)">
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-editing mode="cell"
                    [allowUpdating]="!isEditingDisabled"
                    [allowAdding]="false"
                    [allowDeleting]="!isEditingDisabled"
                    [useIcons]="true">
        </dxo-editing>
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-scrolling mode="virtual"></dxo-scrolling>

        <dxi-column dataField="TransportArticleId" caption="{{languageService.LNG('Label.Articles')}}" [setCellValue]="setTransportArticleValue"
                    cellTemplate="transportArticleCellTemplate" editCellTemplate="transportArticleEditCellTemplate"  >
        </dxi-column>
        <dxi-column dataField="Quantity" caption="{{languageService.LNG('Label.Quantity')}}" ></dxi-column>
        <dxi-column dataField="TransportQuantityUnitCode"  [allowEditing]="false" caption="" ></dxi-column>
        <div *dxTemplate="let data of 'transportArticleCellTemplate'">
            {{data.data.Code}} - {{data.data.Description}}
        </div>
        <div *dxTemplate="let data of 'transportArticleEditCellTemplate'">
                <dx-select-box [dataSource]="transportArticleDataSource"
                            displayExpr="DisplayName"
                            searchExpr="DisplayName"
                            [grouped]="true"
                            valueExpr="TransportArticleId"
                            (onValueChanged)="onTransportArticleChanged($event, data)"
                            [value]="data.data.TransportArticleId">
                </dx-select-box>
        </div>
        <div *dxTemplate="let data of 'headerTitle'">
            <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Articles")}}</span>
        </div>
    </dx-data-grid>
</app-elevation-section>
